const config: BrandingConfig = {
  name: 'remoteit',
  appName: 'Remote.It',
  androidPackageName: 'com.remoteit',
  package: {
    homepage: 'https://app.remote.it',
    description: 'Remote.It cross platform desktop application for creating and hosting connections',
    author: {
      name: 'Remote.It',
      email: 'support@remote.it',
    },
    repository: {
      type: 'git',
      url: 'git+ssh://git@github.com/remoteit/desktop.git',
    },
    build: {
      appId: 'it.remote.desktop',
      copyright: 'remot3.it, Inc',
      productName: 'Remote.It',
    },
  },
  colors: {
    light: {
      brandPrimary: '#0096e7',
      brandSecondary: '#034b9d',
    },
    dark: {
      brandPrimary: '#0096e7',
      brandSecondary: '#034b9d',
    },
  },
}

export default config
